import { render } from "./DragonHunterBacktest.vue?vue&type=template&id=25ca116a&scoped=true&ts=true"
import script from "./DragonHunterBacktest.vue?vue&type=script&lang=ts"
export * from "./DragonHunterBacktest.vue?vue&type=script&lang=ts"

import "./DragonHunterBacktest.vue?vue&type=style&index=0&id=25ca116a&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ca116a"]])

export default __exports__